import { render, staticRenderFns } from "./Song.vue?vue&type=template&id=4c098cc8&scoped=true&"
import script from "./Song.vue?vue&type=script&lang=js&"
export * from "./Song.vue?vue&type=script&lang=js&"
import style0 from "./Song.vue?vue&type=style&index=0&id=4c098cc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c098cc8",
  null
  
)

export default component.exports